import { render, staticRenderFns } from "./ElementTopListComp.vue?vue&type=template&id=a08476bc&"
import script from "./ElementTopListComp.vue?vue&type=script&lang=js&"
export * from "./ElementTopListComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports